import {
  provideHttpClient,
  withInterceptors,
  withXhr
} from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { authHttpInterceptorFn } from '@auth0/auth0-angular';
import { provideNotificationService } from '@bannerflow/notification';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideAuth } from './configs/auth.provider';
import { providePREnvPicker } from '@bannerflow/ui';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptors([authHttpInterceptorFn])),
    provideAuth(environment),
    provideAnimationsAsync(), // Needed for @bannerflow/ui
    provideNotificationService({
      apiUri: environment.origins['notificationServiceApi'],
      accessToken$: new BehaviorSubject<string | undefined>(undefined),
      signalR: {
        enabled: environment.NSSignalR.enabled,
        url: environment.NSSignalR.url
      }
    }),
    providePREnvPicker({
      beRepos: [
        {
          path: 'notification-service',
          repoName: 'notification-service'
        }
      ],
      feRepos: [
        {
          repoName: 'notification-service-client',
          skipRedirection: false
        }
      ]
    })
  ]
};
